import { Card } from 'react-bootstrap';

import styles from './AdCard.module.css';

function AdCard() {
  return (
    <>
      <Card className={styles.AdCard}>
        <div className={styles.AdCardInner}>
          <ins className="eas6a97888e2" data-zoneid="5580846"></ins>
        </div>
        <div className={styles.AdCardSubtitle}>Advertisements</div>
      </Card>
    </>
  );
}

export default AdCard

